module.exports = __webpack_public_path__ + "img/turbo_on.8fb5a977.svg";